module.exports = __webpack_public_path__ + "static/img/pupil--small.c7d22a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/classroom/pupil--small.svg
// module id = 156
// module chunks = 2